import { render } from "./consultHome.vue?vue&type=template&id=d2b9c7e2&scoped=true"
import script from "./consultHome.vue?vue&type=script&lang=js"
export * from "./consultHome.vue?vue&type=script&lang=js"

import "./consultHome.vue?vue&type=style&index=0&id=d2b9c7e2&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b9c7e2"]])

export default __exports__